import {changeMapView, setOverlayOn} from '@explorer/actions/map';

export const buildMapActions = storedState => {
  const actions = [];
  if (storedState.map) {
    if (storedState.map.center || storedState.map.zoom) {
      actions.push(
        changeMapView({
          center: storedState.map.center ? storedState.map.center : undefined,
          zoom: storedState.map.zoom,
        })
      );
    }

    if (storedState.map.overlays) {
      storedState.map.overlays.forEach(overlay => {
        actions.push(setOverlayOn(overlay));
      });
    }
  }
  return actions;
};
